module.exports = __webpack_public_path__ + "static/5-7d57d68efd97ed0c3fef599e925565d4.jpg";